import { Typography, Skeleton, Spin, Tree } from 'antd';
import { TreeProps } from 'antd/es/tree';
import ContextMenu from './contextmenu';

interface PageTreePanelProps {
    loadingInitial: boolean;
    loadingTree: boolean;
    data: TreeProps['treeData'];
    getRootNodeKey: () => string;
    handleRightClick: TreeProps['onRightClick'];
    onSelect: TreeProps['onSelect'];
    onDrop: TreeProps['onDrop'];
    renderTreeTitle: (node: any) => React.ReactNode;
    isEditable: boolean;
    contextMenu: {
        visible: boolean;
        x: number;
        y: number;
    };
    setContextMenu: (menu: { visible: boolean; x: number; y: number }) => void;
    onMenuClick: (info: any) => void;
}

const PageTreePanel: React.FC<PageTreePanelProps> = ({
    loadingInitial,
    loadingTree,
    data,
    getRootNodeKey,
    handleRightClick,
    onSelect,
    onDrop,
    renderTreeTitle,
    isEditable,
    contextMenu,
    setContextMenu,
    onMenuClick,
}) => {
    return (
        <>
            <Typography.Title
                level={4}
                style={{
                    paddingInline: '15px',
                    paddingBlockStart: '5px',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    flexShrink: 0,
                    paddingBottom: '10px',
                }}
            >
                Page Tree
            </Typography.Title>

            <div
                style={{
                    flex: 1,
                    overflowY: 'auto',
                    paddingInline: '15px',
                }}
            >
                {loadingInitial ? (
                    <Skeleton active style={{ paddingBottom: '16px' }} />
                ) : (
                    <Spin spinning={loadingTree} style={{ width: '100%' }}>
                        <Tree
                            style={{ background: 'transparent', margin: 0 }}
                            showIcon
                            showLine
                            treeData={data}
                            defaultExpandedKeys={[getRootNodeKey()]}
                            onRightClick={handleRightClick}
                            onSelect={onSelect}
                            draggable={isEditable}
                            onDrop={onDrop}
                            titleRender={renderTreeTitle}
                        />
                    </Spin>
                )}
            </div>

            <ContextMenu
                visible={contextMenu.visible}
                x={contextMenu.x}
                y={contextMenu.y}
                onClick={onMenuClick}
                setVisible={(visible) => setContextMenu({ ...contextMenu, visible })}
            />
        </>
    );
};

export default PageTreePanel;